import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer, SuiButton, SuiConfirmDialogWrap } from '@splashthat/sui';
import { getTicketStyleCategories } from 'common/entities/form/styleConfiguration/selectors';
import EditViewHeader from '../../EditView/EditViewHeader';
import FormStyleCollapsibles from '../FormStyleCollapsibles';
import {
    FormStyleTicketEditorTicketPanel,
    FormStyleTicketEditorNamePanel,
    FormStyleTicketEditorDescriptionPanel,
    FormStyleTicketEditorRemainingPanel,
    FormStyleTicketEditorDateTimePanel,
    FormStyleTicketEditorPricePanel,
    FormStyleTicketEditorSoldOutPanel,
    FormStyleTicketEditorQuantityPanel,
} from './Panels';

import { saveEditForm, setOpenTicketStyleEditorSection, deleteTicketStyleCategory } from '../../../actions';
import { getFormId, getOpenTicketStylingSection, getOpenTicketStylingType } from '../../../selectors';

import {
    ticketEditorPanels,
    collapsibleLabels,
    TICKET,
    NAME,
    DESCRIPTION,
    PRICE,
    QUANTITY,
    REMAINING,
    DATE_TIME,
    SOLD_OUT,
    ADD_ON_TICKET,
    NESTED_TICKET,
} from '../../../constants/formStylePanels';

import './FormStyleTicketEditor.styl';

const REVERT_TICKET_STYLE_TEXT = 'Revert to Master Ticket Style';
const REVERT_STYLES_DIALOG_TITLE = 'Revert Ticket Styles to Master?';
const REVERT_STYLES_DIALOG_MESSAGE = 'This will override any styling edits you have made.';
const CANCEL_STYLE_RESET_TEXT = 'Cancel';
const ACCEPT_STYLE_RESET_TEXT = 'Revert';

const collapsibleContentComponents = {
    [TICKET]: <FormStyleTicketEditorTicketPanel />,
    [NAME]: <FormStyleTicketEditorNamePanel />,
    [DESCRIPTION]: <FormStyleTicketEditorDescriptionPanel />,
    [PRICE]: <FormStyleTicketEditorPricePanel />,
    [QUANTITY]: <FormStyleTicketEditorQuantityPanel />,
    [REMAINING]: <FormStyleTicketEditorRemainingPanel />,
    [DATE_TIME]: <FormStyleTicketEditorDateTimePanel />,
    [SOLD_OUT]: <FormStyleTicketEditorSoldOutPanel />,
};

const baseClassName = 'FormStyleTicketEditor';

class FormStyleTicketEditor extends React.Component {
    static propTypes = {
        formId: PropTypes.string.isRequired,
        openTicketType: PropTypes.string,
        openTicketCollapsible: PropTypes.string,
        saveEditForm: PropTypes.func.isRequired,
        setOpenTicketStyleEditorSection: PropTypes.func.isRequired,
        canResetStyles: PropTypes.bool.isRequired,
        deleteTicketStyleCategory: PropTypes.func.isRequired,
    };

    static defaultProps = {
        openTicketCollapsible: null,
        openTicketType: null,
        canResetStyles: false,
    };

    render() {
        const { formId, openTicketType, openTicketCollapsible, canResetStyles } = this.props;

        return (
            <SuiContainer className={baseClassName}>
                <EditViewHeader
                    label={collapsibleLabels[openTicketType] || ''}
                    saveEditFormNode={this.props.saveEditForm}
                    locked={false}
                />
                <FormStyleCollapsibles
                    panels={ticketEditorPanels}
                    collapsibleContentComponents={collapsibleContentComponents}
                    openCollapsible={openTicketCollapsible}
                    setOpenStyleEditorSection={this.props.setOpenTicketStyleEditorSection}
                />
                {canResetStyles && (
                    <SuiContainer variation="flex-center padded">
                        <SuiConfirmDialogWrap
                            dialogBody={
                                <SuiContainer variation="flex-center">
                                    <h1 className={`${baseClassName}__dialog-title`}>{REVERT_STYLES_DIALOG_TITLE}</h1>
                                    {REVERT_STYLES_DIALOG_MESSAGE}
                                </SuiContainer>
                            }
                            onConfirm={() => {
                                this.props.deleteTicketStyleCategory(formId, openTicketType);
                                this.props.saveEditForm();
                            }}
                            confirmLabel={ACCEPT_STYLE_RESET_TEXT}
                            dismissLabel={CANCEL_STYLE_RESET_TEXT}
                        >
                            {(onClick) => (
                                <SuiButton label={REVERT_TICKET_STYLE_TEXT} variation="text" onClick={onClick} />
                            )}
                        </SuiConfirmDialogWrap>
                    </SuiContainer>
                )}
            </SuiContainer>
        );
    }
}

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const openTicketCollapsible = getOpenTicketStylingSection(state);
    const openTicketType = getOpenTicketStylingType(state);
    const ticketStyleCategories = getTicketStyleCategories(state, formId);
    const canResetStyles =
        (openTicketType === ADD_ON_TICKET && ticketStyleCategories.includes(ADD_ON_TICKET)) ||
        (openTicketType === NESTED_TICKET && ticketStyleCategories.includes(NESTED_TICKET));

    return {
        formId,
        openTicketType,
        openTicketCollapsible,
        canResetStyles,
    };
};

const mapDispatchToProps = {
    saveEditForm,
    setOpenTicketStyleEditorSection,
    deleteTicketStyleCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStyleTicketEditor);
